export default __webpack_public_path__ + "static/media/Grips of Erlik.1ed0ba9f.jpg";